const StudentActionTypes = {
  SET_STUDENTS: 'SET_STUDENTS',
  REMOVE_STUDENT: 'REMOVE_STUDENT',
  SET_WARD: 'SET_WARD',
};

export default StudentActionTypes;
